import { AllowedHttpMethods, newYearPopupApiConfig } from '../apiList'
import {
  getAuthenticatedRequestConfig,
  useAxios,
} from '../../../utils/apiUtils'

export type ShowNewYearPopupResponse =
  | {
      show: boolean
    }
  | boolean

const showNewYearPopup = async (
  employeeId: string | number,
): Promise<ShowNewYearPopupResponse> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: newYearPopupApiConfig.showNewYearPopup,
    method: AllowedHttpMethods.get,
    params: { employeeId },
  })
  const response = await useAxios(requestConfig)
  return response.data as ShowNewYearPopupResponse
}

const newYearPopupApi = { showNewYearPopup }

export default newYearPopupApi
